import React, { ReactNode, isValidElement } from 'react';
import { IonContent, IonPage } from '@ionic/react';
import './SplitLayout.css';

interface SplitLayoutProps {
  leftWidth?: string;
  showLeftOnMobile?: boolean;
}

const SplitLayout: React.FC<SplitLayoutProps> = ({
  children,
  leftWidth = '192px',
  showLeftOnMobile = false
}) => {
  // 将子元素转换为数组
  const childrenArray = React.Children.toArray(children);
  
  // 提取左右内容（第一个子元素为左，第二个为右）
  const leftContent = childrenArray[0] || null;
  const rightContent = childrenArray[1] || null;

  // 检查是否提供了过多的子元素
  if (childrenArray.length > 2) {
    console.warn('SplitLayout 只使用前两个子元素，其余子元素将被忽略');
  }

  return (
        <div className="split-container">
          <div 
            className={`fixed-panel ${showLeftOnMobile ? 'mobile-visible' : ''}`}
            style={{ width: leftWidth }}
          >
            {leftContent}
          </div>
          
          <div className="main-panel">
              {rightContent}
          </div>
        </div>
  );
};

export default SplitLayout;  